import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'app-register-financial-institution',
  templateUrl: './register-financial-institution.component.html',
  styleUrls: ['./register-financial-institution.component.scss'],
})
export class RegisterFinancialInstitutionComponent {}
